import { BehaviorSubject, fromEvent } from 'rxjs';
import { EventEmitter, Component, ChangeDetectionStrategy, ElementRef, ViewChild, Output, Input, ContentChild, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CdkVirtualForOf, ScrollingModule } from '@angular/cdk/scrolling';
import { takeWhile, pairwise, filter, debounceTime, map, distinctUntilChanged, merge } from 'rxjs/operators';
import { PageInfo, HighlightTextService } from '@wke/ucc-angular-alt-data';
import { Num, LocalizationModule, Reflection } from '@wke/ucc-angular-alt-common';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from '@wke/ucc-angular-alt-buttons';
import { IconModule } from '@wke/ucc-icons';
import { LoadingDataModule } from '@wke/ucc-angular-alt-drawing';

/**
 * El DataListComponent nos permite listar una lista de objetos mediantes 'tarjetas' de manera vertical.
 * Admite gestión de la edición y tambien paginado.
 * @example
 *  <ngwk-data-list #pagedDataList itemSize="30" (selectionChanged)="onSelectionChanged($event)"
 *  (pageRequested)="onPageRequest($event)" (openRow)="onOpenRow($event)" itemSize="35">
 *  <ng-template>
 *   <ngwk-data-list-item>
 *   </ngwk-data-list-item>
 *  </ng-template>
 * </ngwk-data-list>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@wke/ucc-angular-alt-data';
import * as ɵngcc2 from '@angular/cdk/scrolling';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@wke/ucc-angular-alt-drawing';
import * as ɵngcc5 from '@wke/ucc-angular-alt-common';
import * as ɵngcc6 from '@wke/ucc-icons';
import * as ɵngcc7 from '@wke/ucc-angular-alt-buttons';

const _c0 = ["itemTemplate"];
const _c1 = ["virtualScroll"];
function DataListComponent_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c2 = function (a0) { return { $implicit: a0 }; };
function DataListComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵlistener("click", function DataListComponent_div_3_Template_div_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const item_r4 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onDataListItemClick(item_r4, $event); })("keydown", function DataListComponent_div_3_Template_div_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.processInput($event); });
    ɵngcc0.ɵɵtemplate(2, DataListComponent_div_3_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const index_r5 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r1.getIdByIndex(index_r5));
    ɵngcc0.ɵɵattribute("selected", ctx_r1.isSelected(item_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c2, item_r4));
} }
function DataListComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "ngwk-loading-data");
    ɵngcc0.ɵɵelementEnd();
} }
function DataListComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "grid-no-data"));
} }
function DataListItemComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", ctx_r0.icon);
} }
function DataListItemComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
function DataListItemComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} }
function DataListItemComponent_div_5_ngwk_toolbar_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-toolbar");
    ɵngcc0.ɵɵelementStart(1, "ngwk-toolbar-item", 12);
    ɵngcc0.ɵɵlistener("actionClick", function DataListItemComponent_div_5_ngwk_toolbar_1_Template_ngwk_toolbar_item_actionClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onEdit($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "ngwk-toolbar-item", 13);
    ɵngcc0.ɵɵlistener("actionClick", function DataListItemComponent_div_5_ngwk_toolbar_1_Template_ngwk_toolbar_item_actionClick_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onRemove($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("visible", ctx_r4.allowEdit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("visible", ctx_r4.allowRemove);
} }
function DataListItemComponent_div_5_ngwk_toolbar_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-toolbar");
    ɵngcc0.ɵɵelementStart(1, "ngwk-toolbar-item", 14);
    ɵngcc0.ɵɵlistener("actionClick", function DataListItemComponent_div_5_ngwk_toolbar_2_Template_ngwk_toolbar_item_actionClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onSave($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "ngwk-toolbar-item", 15);
    ɵngcc0.ɵɵlistener("actionClick", function DataListItemComponent_div_5_ngwk_toolbar_2_Template_ngwk_toolbar_item_actionClick_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onDiscard($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r5.canSave);
} }
function DataListItemComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, DataListItemComponent_div_5_ngwk_toolbar_1_Template, 3, 2, "ngwk-toolbar", 11);
    ɵngcc0.ɵɵtemplate(2, DataListItemComponent_div_5_ngwk_toolbar_2_Template, 3, 1, "ngwk-toolbar", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.isEditMode && ctx_r3.isMenuActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isEditMode);
} }
const _c3 = [[["read-view"]], [["edit-view"]]];
const _c4 = ["read-view", "edit-view"];
class DataListComponent {
    /** @ignore */
    constructor(_el, _highlightTextService) {
        this._el = _el;
        this._highlightTextService = _highlightTextService;
        this._itemTemplate = null;
        this._dataItemsSubject$ = new BehaviorSubject([]);
        this._dataItems$ = this._dataItemsSubject$.asObservable();
        this._scrollSubscription = null;
        this._viewPortByScroll$ = new BehaviorSubject(null);
        this._isAlive = true;
        this._allowDeselection = true;
        this._selectedItems = new Array();
        this._lastPageInfo = null;
        this._firstIndexInViewPort = 0;
        this._isLoading = false;
        this._pageSize = 50;
        this._itemSize = 0;
        this._items = null;
        this._trackBy = null;
        this._selectionMode = DataListSelectionMode.SingleByRowClick;
        this._paginationMode = DataListPaginationMode.None;
        this._highlightText = null;
        this._selectionChanged = new EventEmitter();
        this._openRow = new EventEmitter();
        this._pageRequested = new EventEmitter();
        //#endregion
        //#region Subscribers Item events
        this._candidateDoubleClick = null;
        this._itemClickCount = 0;
        this._timerClick = null;
    }
    ngOnInit() {
        if (this.paginationMode === DataListPaginationMode.Virtual) {
            this.subscribeOnScroll();
            this.onPageRequest(this.getNextPageInPageInfo());
        }
        this._highlightTextService.createInstance(this._el.nativeElement);
        this._virtualForOf.viewChange.pipe(takeWhile(() => this._isAlive)).subscribe(() => this.highlightText(this._highlightText));
    }
    ngOnDestroy() {
        this._isAlive = false;
        if (this._scrollSubscription) {
            this._scrollSubscription.unsubscribe();
        }
    }
    //#region Manage Items
    /**
     * Permite añadir un nuevo elemento al DataList
     *
     * @param addItems Elemento a añadir al DataList
     * @return
     */
    addItem(addedItem) {
        this.addItems([addedItem]);
    }
    /**
     * Permite añadir nuevos elementos a la DataList
     *
     * @param addItems Elementos a añadir a la DataList
     * @return
     */
    addItems(addedItems) {
        if (this.items && this.addItems) {
            const currentItems = this.items.slice(0); // copy of array
            addedItems.forEach(i => currentItems.push(i));
            this.items = currentItems;
        }
    }
    /**
     * Permite borrar el elemento indicado en el método
     *
     * @param removedItem Elemento a borrar
     * @return
     */
    removeItem(removedItem) {
        this.removeItems([removedItem]);
    }
    /**
     * Permite borrar los elementos indicados en el método
     *
     * @param removedItems Elementos a borrar
     * @return
     */
    removeItems(removedItems) {
        this.items = this.removeItemsInArray(this.items, removedItems);
        this.selectedItems = this.removeItemsInArray(this.selectedItems, removedItems);
    }
    /**
     * Permite realizar un actualización del elemento.
     *
     * @param editItem Elementos a actualizar
     * @return
     */
    updateItem(editItem) {
        this.updateItems([editItem]);
    }
    /**
     * Permite realizar un actualización de los elementos.
     *
     * @param editItems Elementos a actualizar
     * @return
     */
    updateItems(editItems) {
        const editItem = editItems[0];
        const indexEditedItem = this.items.indexOf(editItem);
        if (indexEditedItem > -1) {
            this.forceRefreshItems();
        }
    }
    /**
   * Permite reemplazar un elemento por otro.
   *
   * @param oldItem Elementos a substituir
   * @param newItem Elemento a mostrar
   * @return
   */
    replaceItem(oldItem, newItem) {
        const indexOldItem = this.items.indexOf(oldItem);
        if (indexOldItem > -1) {
            this.items[indexOldItem] = newItem;
            this.forceRefreshItems();
        }
    }
    /**
    * Fuerza a repintar el datalist.
    *
    * @return
    */
    forceRefreshItems() {
        this.items = this.items.slice(0); // copy of array
    }
    //#endregion
    /**
    * Mover el scroll hasta el elemento
    * @param item elemento hasta el que mover el scroll
    * @return
    */
    scrollTo(item) {
        let index = this.items.indexOf(item);
        if (index > -1) {
            this._virtualScroll.scrollToIndex(index);
        }
    }
    /** @ignore */
    processInput(keyEvent) {
        keyEvent.stopPropagation();
        switch (keyEvent.keyCode) {
            case KEY_UP:
                this.keyboardNavigation('up');
                return false;
                break;
            case KEY_DOWN:
                this.keyboardNavigation('down');
                return false;
                break;
        }
    }
    /**
     * Saber si un elemento está seleccionado.
     * @param item elemento hasta el que mover el scroll
     * @return si el emento está seleccionado.
     */
    isSelected(item) {
        return this._selectedItems.indexOf(item) !== -1 ? true : null;
    }
    /** @ignore */
    getIdByIndex(index) {
        return `dli_${index}`;
    }
    // #region Pagination
    /**
     * Permite recargar la DataList
     */
    refresh() {
        if (this._paginationMode === DataListPaginationMode.Virtual) {
            this._scrollSubscription.unsubscribe();
            let pageInfo = new PageInfo(1, this._pageSize);
            this.items = null;
            this.onPageRequest(pageInfo);
            this.subscribeOnScroll();
        }
    }
    /**
     * Permite añadir la respuesta de la petición y cargar los datos de esta a la DataList
     *
     * @param response Respuesta a añadir al DataList
     */
    addResponse(response) {
        this._lastPageInfo = response.pageInfo;
        this._isLoading = false;
        if (PageInfo.IsFirstPage(this._lastPageInfo)) {
            this.items = response.values;
            this._virtualScroll.scrollToIndex(0);
        }
        else {
            this.items = this.items.concat(response.values);
        }
    }
    /** @ignore */
    onViewPortScrolled(index) {
        this._firstIndexInViewPort = index;
        this._viewPortByScroll$.next(index);
    }
    onPageRequest(pageInfo) {
        let request = {
            pageInfo: pageInfo
        };
        if (request.pageInfo.pageNumber === 1) {
            this._lastPageInfo = null;
        }
        this._isLoading = true;
        this.pageRequested.emit(request);
    }
    subscribeOnScroll() {
        this._scrollSubscription = this._viewPortByScroll$
            .pipe(
        // returns an array of current emitted data and also the previous emitted data .
        pairwise(), 
        // create a stream with the filtered values
        // we only need the values from when we are scrolling outside
        // our viewport
        filter((indexItems) => this.isUserScrollingDown(indexItems) &&
            this.canRequestPage(this.lastIndexInViewPort)), 
        // Only when the user stops scrolling for 200 ms, we can continue
        // so let's debounce this stream for 200 ms
        debounceTime(200), 
        // calculate the page number
        map(() => this.getNextPage()), 
        // filter out double values
        distinctUntilChanged())
            .subscribe(page => this.onPageRequest(new PageInfo(page, this._pageSize)));
    }
    isUserScrollingDown(indexItems) {
        return indexItems[0] < indexItems[1];
    }
    canRequestPage(lastItemViewedIndex) {
        let lastItemRelativePosition = lastItemViewedIndex / this._virtualScroll.getDataLength();
        return (lastItemRelativePosition > 0.8 &&
            (this.items === null || this._lastPageInfo.total > this.items.length));
    }
    getNextPageInPageInfo() {
        let pageNumber = this.getNextPage();
        let pageInfo = new PageInfo(pageNumber, this._pageSize);
        pageInfo.retrieveTotal = pageNumber === 1;
        return pageInfo;
    }
    getNextPage() {
        return (this.items ? this.items.length : 0) / this._pageSize + 1;
    }
    // #endregion
    removeItemsInArray(items, removedItems) {
        const copyItems = items.slice(0); // copy of array
        removedItems.forEach(ri => copyItems.indexOf(ri) > -1
            ? copyItems.splice(copyItems.indexOf(ri), 1)
            : null);
        return copyItems;
    }
    //#region Highlight
    /**
    * Permite resaltar el texto indicado en el parámetro 'text' en toda la DataList
    *
    * @param text Texto a resaltar en la DataList
    * @return
    */
    highlightText(text) {
        this._highlightText = text;
        this._highlightTextService.unmark();
        if (this._highlightText) {
            this._highlightTextService.mark(this._highlightText);
        }
    }
    /**
     * Permite resetear el texto resaltado por el método 'highlightText'
     *
     * @return
     */
    resetHighlightText() {
        this.highlightText(null);
    }
    //#endregion
    //#region keyboardNavigation
    keyboardNavigation(scrollDirection) {
        let scrollOffset = null;
        if (this.items && this.items.length > 0) {
            const nextSelectedItem = scrollDirection === 'up' ?
                this.items[0] !== this.selectedItem ? this.items[this.items.indexOf(this.selectedItem) - 1] : this.selectedItem
                :
                    this.items.length > this.items.indexOf(this.selectedItem) + 1 ? this.items[this.items.indexOf(this.selectedItem) + 1] : this.selectedItem;
            const indexSelectedItem = this.items.indexOf(nextSelectedItem);
            const itemSize = Num.parse(this.itemSize);
            if (scrollDirection === 'down' && indexSelectedItem >= this.lastIndexInViewPort) {
                scrollOffset = ((indexSelectedItem + 1) * itemSize) - this.containerSize;
            }
            else if (scrollDirection === 'up' && indexSelectedItem <= this._firstIndexInViewPort) {
                scrollOffset = indexSelectedItem * itemSize;
            }
            this.setFocusByIndex(indexSelectedItem);
            this.selectedItem = nextSelectedItem;
            if (scrollOffset !== null) {
                this._virtualScroll.scrollToOffset(scrollOffset);
            }
        }
    }
    // #endregion
    //#region Utils
    setFocusByIndex(index) {
        const element = this._el.nativeElement.querySelector(`#${this.getIdByIndex(index)}`);
        if (element) {
            setTimeout(() => element.focus(), 0);
        }
    }
    get lastIndexInViewPort() {
        const itemsPerViewPort = Math.round(this.containerSize / this.itemSize);
        return itemsPerViewPort + this._firstIndexInViewPort;
    }
    get containerSize() {
        return this._virtualScroll.elementRef.nativeElement.clientHeight;
    }
    /** @ignore */
    onDataListItemClick(selectedItem, event) {
        event.stopPropagation();
        this.onSelectItem(selectedItem, event);
        if (this._candidateDoubleClick !== selectedItem) {
            this._candidateDoubleClick = selectedItem;
            this._itemClickCount = 0;
            clearTimeout(this._timerClick);
        }
        this._itemClickCount++;
        if (this._itemClickCount === 2) {
            this._itemClickCount = 0;
            clearTimeout(this._timerClick);
            this.onOpenRowItem(selectedItem);
        }
        this._timerClick = setTimeout(() => this._itemClickCount = 0, 250);
    }
    /** @ignore */
    onSelectItem(selectedItem, event) {
        this.setSelectedItems([selectedItem], event.ctrlKey);
    }
    setSelectedItems(selectedItems, isCtrlPressed = false) {
        let newSelectedItems = [];
        const resetSelectedItems = !DataListSelectionModeHelper.isMultiple(this._selectionMode) ||
            (DataListSelectionModeHelper.isMultiple(this._selectionMode) && !DataListSelectionModeHelper.hasCheck(this._selectionMode) && !isCtrlPressed);
        if (isCtrlPressed && this.allowDeselection) {
            for (let item of selectedItems) {
                const indexSelectedItem = this._selectedItems.indexOf(item);
                indexSelectedItem > -1 ? this._selectedItems.splice(indexSelectedItem, 1) : newSelectedItems.push(item);
            }
        }
        else {
            newSelectedItems = selectedItems;
        }
        this._selectedItems = resetSelectedItems ? newSelectedItems : this._selectedItems.concat(newSelectedItems);
        this.selectionChanged.emit(this.selectedItems);
    }
    onOpenRowItem(item) {
        this.openRow.emit(item);
    }
    //#endregion Private Methods
    //#region Properties
    /**
     * Emite un evento cuando se cambia la selección.
     */
    get selectionChanged() {
        return this._selectionChanged;
    }
    /**
     * Emite un evento cuando se hace dobleclick sobre una fila.
     */
    get openRow() {
        return this._openRow;
    }
    /**
     * Emite un evento cuando, en modo paginación, se requiere de una nueva página.
     */
    get pageRequested() {
        return this._pageRequested;
    }
    /**
       * Permite obtener el elemento seleccionado
       *
       * @return
       */
    get selectedItem() {
        return this._selectedItems.length > 0 ? this._selectedItems[0] : null;
    }
    /**
     * Permite definir el elemento a seleccionar
     *
     * @param value elemento a seleccionar
     */
    set selectedItem(value) {
        this.setSelectedItems([value]);
    }
    /**
    * Permite obtener los elementos que esten seleccionadas
    *
    * @return
    */
    get selectedItems() {
        return this._selectedItems;
    }
    /**
     * Permite definir los elementos a seleccionar
     *
     * @param value elemento a seleccionar
     */
    set selectedItems(value) {
        this.setSelectedItems(value);
    }
    /**
     * Permite obtener los datos que estan cargados.
     *
     * @return
     */
    get items() {
        return this._items;
    }
    /**
     * Permite definir los datos que estan cargados.
     *
     * @param value elementos a cargar
     */
    set items(value) {
        this._items = value;
        this._dataItemsSubject$.next(this._items);
    }
    /**
     * Permite obtener la altura de la filas (tarjetas)
     */
    get itemSize() {
        return this._itemSize;
    }
    /**
    * Permite definir la altura de las filas (tarjetas)
    *
    * @param value altura en píxles de una fila.
    */
    set itemSize(value) {
        this._itemSize = value;
    }
    /**
     * Permite obtener si se puede dejar el listado sin ningun elemento seleccionado.
     */
    get allowDeselection() {
        return this._allowDeselection;
    }
    /**
     * Permite definir si se peude dejar el listado sin ningun elemento seleccionado.
     *
     * @param value sise pueden deseleccionar todos los elementos del listado.
     */
    set allowDeselection(value) {
        this._allowDeselection = value;
    }
    /**
     * Permite obtener la funcion de trackBy
     */
    get trackBy() {
        return this._trackBy;
    }
    /**
     * Una función que define cómo hacer un seguimiento de los cambios de los elementos en el iterable.
     * Cuando se añaden, mueven o eliminan elementos en el iterable, la directiva debe volver a mostrar los nodos DOM apropiados. Para minimizar el churn en el DOM, sólo se vuelven a renderizar los nodos que han cambiado.
     * Por defecto, el detector de cambios asume que la instancia de objeto identifica el nodo en el iterable. Cuando se proporciona esta función, la directiva utiliza el resultado de llamar a esta función para identificar el nodo del elemento, en lugar de la identidad del propio objeto.
     * La función recibe dos entradas, el índice de iteración y el ID de objeto de nodo.
     *
     * @param value Función para saber si un objeto ha cambiado o no.
     */
    set trackBy(value) {
        this._trackBy = value;
    }
    /**
       * Permite obtener el modo de selección, los cuales pueden ser SingleByRowClick y MultipleByRowClick
       *
       * @return
       */
    get selectionMode() {
        return this._selectionMode;
    }
    /**
     * Permite definir el modo de selección, los cuales pueden ser SingleByRowClick y MultipleByRowClick
     *
     * @param value Nueva modo de selección
     * @return
     */
    set selectionMode(value) {
        this._selectionMode = value;
    }
    /**
     * Permite obtener el modo de paginación, los cuales pueden ser el none (sin paginación) o virtual (paginación)
     *
     * @return
     */
    get paginationMode() {
        return this._paginationMode;
    }
    /**
    * Permite definir el modo de paginación, los cuales pueden ser el none (sin paginación) o virtual (paginación)
    *
    * @param value Nuevo modo de paginación
    * @return
    */
    set paginationMode(value) {
        this._paginationMode = value;
    }
    /**
     * Este getter permite saber si los datos estan cargados o no.
     *
     * @return
     */
    get isLoading() {
        return this._isLoading;
    }
    /**
     * Permite activar o desactivar el template de cargando datos
     *
     * @param value
     * @return
     */
    set isLoading(value) {
        this._isLoading = value;
    }
    /**
     * Permite obetener el template de un elemento.
     */
    get itemTemplate() {
        return this._itemTemplate;
    }
    /**
     * Permite definir el template que representará cada elemento en el listado.
     */
    set itemTemplate(value) {
        this._itemTemplate = value;
    }
    /**
     * Observable que nos notifica el nuevo array de datos cuando hay cambios.
     */
    get data() {
        return this._dataItems$;
    }
    /**
     * Permite obtener si hay datos cargados.
     */
    get hasData() {
        return this.items && this.items.length > 0;
    }
}
DataListComponent.ɵfac = function DataListComponent_Factory(t) { return new (t || DataListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.HighlightTextService)); };
DataListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataListComponent, selectors: [["ngwk-data-list"]], contentQueries: function DataListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
    } }, viewQuery: function DataListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 7);
        ɵngcc0.ɵɵviewQuery(CdkVirtualForOf, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._virtualScroll = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._virtualForOf = _t.first);
    } }, inputs: { items: "items", selectedItems: "selectedItems", selectedItem: "selectedItem", itemSize: "itemSize", allowDeselection: "allowDeselection", trackBy: "trackBy", selectionMode: "selectionMode", paginationMode: "paginationMode", isLoading: "isLoading" }, outputs: { selectionChanged: "selectionChanged", openRow: "openRow", pageRequested: "pageRequested" }, features: [ɵngcc0.ɵɵProvidersFeature([HighlightTextService])], decls: 7, vars: 8, consts: [[2, "position", "relative", "width", "100%", "height", "100%"], [2, "width", "100%", "height", "100%", 3, "itemSize", "scrolledIndexChange"], ["virtualScroll", ""], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplateCacheSize"], ["class", "infoGridCenter infoGridLoading", 4, "ngIf"], ["class", "infoGridCenter infoGridNoData", 4, "ngIf"], ["tabindex", "-1", 1, "dataListItem", 3, "id", "click", "keydown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "infoGridCenter", "infoGridLoading"], [1, "infoGridCenter", "infoGridNoData"]], template: function DataListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "cdk-virtual-scroll-viewport", 1, 2);
        ɵngcc0.ɵɵlistener("scrolledIndexChange", function DataListComponent_Template_cdk_virtual_scroll_viewport_scrolledIndexChange_1_listener($event) { return ctx.onViewPortScrolled($event); });
        ɵngcc0.ɵɵtemplate(3, DataListComponent_div_3_Template, 3, 6, "div", 3);
        ɵngcc0.ɵɵpipe(4, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DataListComponent_div_5_Template, 2, 0, "div", 4);
        ɵngcc0.ɵɵtemplate(6, DataListComponent_div_6_Template, 4, 3, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("itemSize", ctx.itemSize);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkVirtualForOf", ɵngcc0.ɵɵpipeBind1(4, 6, ctx.data))("cdkVirtualForTrackBy", ctx.trackBy)("cdkVirtualForTemplateCacheSize", 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading && !ctx.hasData);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading && !ctx.hasData);
    } }, directives: [ɵngcc2.CdkVirtualScrollViewport, ɵngcc2.CdkFixedSizeVirtualScroll, ɵngcc2.CdkVirtualForOf, ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet, ɵngcc4.LoadingDataComponent], pipes: [ɵngcc3.AsyncPipe, ɵngcc5.LocalePipe], styles: ["[_nghost-%COMP%]     .dataListItem{background-color:#f7f7f7;width:100%;border-radius:3px;margin-bottom:5px;padding-left:10px;font-size:13px;color:#373737;user-select:none;touch-action:manipulation;display:flex;align-items:center}[_nghost-%COMP%]     .dataListItem .iconFixDataList{margin-right:10px}[_nghost-%COMP%]     .dataListItem .iconFixDataList ucc-icon{font-size:13px;color:#fdc228}[_nghost-%COMP%]     .dataListItem>:first-child{width:100%;display:flex;align-items:center}[_nghost-%COMP%]     .dataListItem:hover{background-color:#e7e7e7}[_nghost-%COMP%]     .dataListItem:hover .transparentToolbar{background:linear-gradient(to right,#e7e7e7 0%,#e7e7e7 35%,#fefefe 100%)!important}[_nghost-%COMP%]     .dataListItem:hover .transparentToolbar ucc-icon{cursor:pointer}[_nghost-%COMP%]     .dataListItem[selected]{background-color:#e0eff9}[_nghost-%COMP%]     .dataListItem[selected] .transparentToolbar{background:linear-gradient(to right,#e0eff9 0%,#e0eff9 20%,#e0eff9 35%,#fefefe 100%)!important}[_nghost-%COMP%]     ngwk-data-list-item{height:30px}[_nghost-%COMP%]     ngwk-data-list-item ngwk-toolbar-item{padding-left:5px;cursor:pointer;margin-left:10px}[_nghost-%COMP%]     ngwk-data-list-item ngwk-toolbar-item ucc-icon{color:#666}[_nghost-%COMP%]     ngwk-data-list-item ngwk-toolbar-item ucc-icon:hover{color:#373737;background-color:transparent!important}[_nghost-%COMP%]     ngwk-data-list-item ngwk-toolbar-item[disabled]{opacity:.5!important;background-color:transparent!important;cursor:default!important;pointer-events:none;color:#b3bddc!important}[_nghost-%COMP%]     .transparentToolbar{height:100%;width:80px;justify-content:flex-end}[_nghost-%COMP%]     .transparentToolbar .wkToolbar{margin-right:10px}[_nghost-%COMP%]     .dataListReadView{height:100%}[_nghost-%COMP%]     .dataListReadView read-view{height:100%;display:flex;align-items:center}[_nghost-%COMP%]     .dataListEditView{height:100%}[_nghost-%COMP%]     .dataListEditView input{background-color:transparent;border:none;border-bottom:1px solid #373737;width:100%;height:100%;padding:0 5px;margin-right:10px}[_nghost-%COMP%]     read-view{display:flex}[_nghost-%COMP%]     edit-view{height:100%;display:flex;align-items:center}[_nghost-%COMP%]     ngwk-company-selector read-view{display:grid}[_nghost-%COMP%]     .infoGridCenter{display:flex;align-items:center;justify-content:center;position:absolute;height:100%;width:100%;top:0px}[_nghost-%COMP%]     .infoGridCenter.infoGridLoading{font-size:13px;color:#666}[_nghost-%COMP%]     .infoGridCenter.infoGridNoData{color:#999;font-size:13px}"], changeDetection: 0 });
/** @nocollapse */
DataListComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: HighlightTextService }
];
DataListComponent.propDecorators = {
    _virtualScroll: [{ type: ViewChild, args: ["virtualScroll", { static: true },] }],
    _virtualForOf: [{ type: ViewChild, args: [CdkVirtualForOf, { static: true },] }],
    selectionChanged: [{ type: Output }],
    openRow: [{ type: Output }],
    pageRequested: [{ type: Output }],
    selectedItem: [{ type: Input }],
    selectedItems: [{ type: Input }],
    items: [{ type: Input }],
    itemSize: [{ type: Input }],
    allowDeselection: [{ type: Input }],
    trackBy: [{ type: Input }],
    selectionMode: [{ type: Input }],
    paginationMode: [{ type: Input }],
    isLoading: [{ type: Input }],
    itemTemplate: [{ type: ContentChild, args: ["itemTemplate", { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataListComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-data-list",
                template: "<div style=\"position: relative; width: 100%; height: 100%\">\r\n  <cdk-virtual-scroll-viewport #virtualScroll [itemSize]=\"itemSize\" style=\"width: 100%; height: 100%\"\r\n    (scrolledIndexChange)=\"onViewPortScrolled($event)\">\r\n    <div *cdkVirtualFor=\"let item of data | async; let index = index; trackBy: trackBy; templateCacheSize: 0\"> <!--  viewChange: onViewChange; -->\r\n      <div class=\"dataListItem\" [id]=\"getIdByIndex(index)\" tabindex=\"-1\"\r\n        (click)=\"onDataListItemClick(item, $event)\"\r\n        [attr.selected]=\"isSelected(item)\"\r\n        (keydown)=\"processInput($event)\">\r\n        <ng-container *ngTemplateOutlet=\"itemTemplate;context:{$implicit: item}\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </cdk-virtual-scroll-viewport>\r\n\r\n  <div *ngIf=\"isLoading && !hasData\" class=\"infoGridCenter infoGridLoading\">\r\n    <ngwk-loading-data></ngwk-loading-data>\r\n  </div>\r\n  <div *ngIf=\"!isLoading && !hasData\" class=\"infoGridCenter infoGridNoData\">\r\n    <span>{{'grid-no-data' | locale }}</span>\r\n  </div>\r\n</div>\r\n",
                providers: [HighlightTextService],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host ::ng-deep .dataListItem{background-color:#f7f7f7;width:100%;border-radius:3px;margin-bottom:5px;padding-left:10px;font-size:13px;color:#373737;user-select:none;touch-action:manipulation;display:flex;align-items:center}:host ::ng-deep .dataListItem .iconFixDataList{margin-right:10px}:host ::ng-deep .dataListItem .iconFixDataList ucc-icon{font-size:13px;color:#fdc228}:host ::ng-deep .dataListItem>:first-child{width:100%;display:flex;align-items:center}:host ::ng-deep .dataListItem:hover{background-color:#e7e7e7}:host ::ng-deep .dataListItem:hover .transparentToolbar{background:linear-gradient(to right,#e7e7e7 0%,#e7e7e7 35%,#fefefe 100%)!important}:host ::ng-deep .dataListItem:hover .transparentToolbar ucc-icon{cursor:pointer}:host ::ng-deep .dataListItem[selected]{background-color:#e0eff9}:host ::ng-deep .dataListItem[selected] .transparentToolbar{background:linear-gradient(to right,#e0eff9 0%,#e0eff9 20%,#e0eff9 35%,#fefefe 100%)!important}:host ::ng-deep ngwk-data-list-item{height:30px}:host ::ng-deep ngwk-data-list-item ngwk-toolbar-item{padding-left:5px;cursor:pointer;margin-left:10px}:host ::ng-deep ngwk-data-list-item ngwk-toolbar-item ucc-icon{color:#666}:host ::ng-deep ngwk-data-list-item ngwk-toolbar-item ucc-icon:hover{color:#373737;background-color:transparent!important}:host ::ng-deep ngwk-data-list-item ngwk-toolbar-item[disabled]{opacity:.5!important;background-color:transparent!important;cursor:default!important;pointer-events:none;color:#b3bddc!important}:host ::ng-deep .transparentToolbar{height:100%;width:80px;justify-content:flex-end}:host ::ng-deep .transparentToolbar .wkToolbar{margin-right:10px}:host ::ng-deep .dataListReadView{height:100%}:host ::ng-deep .dataListReadView read-view{height:100%;display:flex;align-items:center}:host ::ng-deep .dataListEditView{height:100%}:host ::ng-deep .dataListEditView input{background-color:transparent;border:none;border-bottom:1px solid #373737;width:100%;height:100%;padding:0 5px;margin-right:10px}:host ::ng-deep read-view{display:flex}:host ::ng-deep edit-view{height:100%;display:flex;align-items:center}:host ::ng-deep ngwk-company-selector read-view{display:grid}:host ::ng-deep .infoGridCenter{display:flex;align-items:center;justify-content:center;position:absolute;height:100%;width:100%;top:0px}:host ::ng-deep .infoGridCenter.infoGridLoading{font-size:13px;color:#666}:host ::ng-deep .infoGridCenter.infoGridNoData{color:#999;font-size:13px}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.HighlightTextService }]; }, { items: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], selectionChanged: [{
            type: Output
        }], openRow: [{
            type: Output
        }], pageRequested: [{
            type: Output
        }], itemSize: [{
            type: Input
        }], allowDeselection: [{
            type: Input
        }], trackBy: [{
            type: Input
        }], selectionMode: [{
            type: Input
        }], paginationMode: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], itemTemplate: [{
            type: ContentChild,
            args: ["itemTemplate", { static: true }]
        }], _virtualScroll: [{
            type: ViewChild,
            args: ["virtualScroll", { static: true }]
        }], _virtualForOf: [{
            type: ViewChild,
            args: [CdkVirtualForOf, { static: true }]
        }] }); })();
/**
 * @ignore
 */
var DataListPaginationMode;
(function (DataListPaginationMode) {
    DataListPaginationMode[DataListPaginationMode["None"] = 1] = "None";
    DataListPaginationMode[DataListPaginationMode["Virtual"] = 2] = "Virtual";
})(DataListPaginationMode || (DataListPaginationMode = {}));
/**
 * @ignore
 */
var DataListSelectionMode;
(function (DataListSelectionMode) {
    DataListSelectionMode[DataListSelectionMode["SingleByRowClick"] = 1] = "SingleByRowClick";
    DataListSelectionMode[DataListSelectionMode["MultipleByRowClick"] = 2] = "MultipleByRowClick";
})(DataListSelectionMode || (DataListSelectionMode = {}));
/**
 * @ignore
 */
var DataListSelectionModeHelper;
(function (DataListSelectionModeHelper) {
    /**
     * @ignore
     */
    function hasCheck(selectionMode) {
        switch (selectionMode) {
            case DataListSelectionMode.SingleByRowClick:
            case DataListSelectionMode.MultipleByRowClick:
                return false;
            default:
                return true;
        }
    }
    DataListSelectionModeHelper.hasCheck = hasCheck;
    /**
     * @ignore
     */
    function isMultiple(selectionMode) {
        switch (selectionMode) {
            case DataListSelectionMode.SingleByRowClick:
                return false;
            default:
                return true;
        }
    }
    DataListSelectionModeHelper.isMultiple = isMultiple;
})(DataListSelectionModeHelper || (DataListSelectionModeHelper = {}));
/** @ignore */
const KEY_LEFT = 37;
/** @ignore */
const KEY_UP = 38;
/** @ignore */
const KEY_RIGHT = 39;
/** @ignore */
const KEY_DOWN = 40;
/** @ignore */
const KEY_PAGE_UP = 33;
/** @ignore */
const KEY_PAGE_DOWN = 34;
/** @ignore */
const KEY_PAGE_HOME = 36;
/** @ignore */
const KEY_PAGE_END = 35;

/**
 * El DataListItemComponent representa una tarjeta del {@link DataListComponent}.
 * Permite definir una vista de lectura <read-view> y otra de edición <edit-view>. Podemos administrar estas vistas mediante inputs y outputs.
 * Por otro lado, le podemos asignar una estrategia de edición como es {@link SingleEditStrategy}
 * @example
 * <ngwk-data-list>
 *  <ng-template #itemTemplate let-item>
 *   <ngwk-data-list-item
 *    [value]="item"
 *    [editStrategy]="_editStrategy"
 *    [icon]="getIcon(item)"
 *    [canEdit]="canEdit(item)"
 *    [canSave]="canSave(item)"
 *    canRemove="true"
 *    (remove)="onRemovePerson($event)"
 *    (editionStarted)="onEditionPersonStart(item)"
 *    (save)="onSavePerson($event)"
 *    (discard)="onDiscardPerson($event)">
 *    <read-view>
 *     {{item.name}}
 *    </read-view>
 *    <edit-view>
 *     <ngwk-text-box [(ngModel)]="item.name"></ngwk-text-box>
 *    </edit-view>
 *   </ngwk-data-list-item>
 *  </ng-template>
 * </ngwk-data-list>
 *
 */
class DataListItemComponent {
    /** @ignore */
    constructor(_el) {
        this._el = _el;
        this._canEdit = true;
        this._canRemove = true;
        this._canSave = true;
        this._value = null;
        this._icon = null;
        this._isMenuActive = false;
        this._editStrategy = null;
        this._remove = new EventEmitter();
        this._save = new EventEmitter();
        this._discard = new EventEmitter();
        this._editionStarted = new EventEmitter();
        const mouseOut$ = fromEvent(this._el.nativeElement, 'mouseout');
        fromEvent(this._el.nativeElement, 'mouseover')
            .pipe(merge(mouseOut$), debounceTime(50), filter((event) => event.type === 'mouseover'))
            .subscribe(() => (this._isMenuActive = true));
        fromEvent(this._el.nativeElement, 'mouseout')
            .pipe(filter((event) => !this._el.nativeElement.contains(event.relatedTarget)))
            .subscribe(() => (this._isMenuActive = false));
    }
    //#region private methods
    edit() {
        if (this.allowEdit && this.editStrategy) {
            this.editStrategy.set(this.value);
            this.editionStarted.emit(this.value);
        }
    }
    discarded() {
        if (this.editStrategy) {
            this.editStrategy.discardChanges(this.value);
            this.discard.emit(this.value);
        }
    }
    //#endregion private methods
    //#region public methods
    /** @ignore */
    onEdit(event) {
        event.stopPropagation();
        this.edit();
    }
    /** @ignore */
    onRemove(event) {
        event.stopPropagation();
        if (this.allowRemove) {
            this.remove.emit(this.value);
        }
    }
    /** @ignore */
    onSave(event) {
        event.stopPropagation();
        if (this.canSave) {
            this.editStrategy.remove(this.value);
            this.save.emit(this.value);
        }
    }
    /** @ignore */
    onDiscard(event) {
        event.stopPropagation();
        this.discarded();
    }
    //#endregion
    //#region Properties
    /** @ignore */
    get isMenuActive() {
        return this._isMenuActive;
    }
    /** @ignore */
    get allowEdit() {
        return this.canEdit && (!this.editStrategy || this.editStrategy.canEdit);
    }
    /** @ignore */
    get isEditMode() {
        return this.editStrategy && this.editStrategy.exist(this.value);
    }
    /** @ignore */
    get allowRemove() {
        return this.canRemove && !this.isEditMode;
    }
    //#region Inputs
    /**
     * Permite obtener si el elemento se puede editar.
     */
    get canEdit() {
        return this._canEdit;
    }
    /**
     * Permite definir si el elemento es editable
     *
     * @param value indicar si es editable
     */
    set canEdit(value) {
        this._canEdit = value;
    }
    /**
   * Permite obtener si el elemento se puede eliminar.
   */
    get canRemove() {
        return this._canRemove;
    }
    /**
    * Permite definir si el elemento se puede eliminar
    *
    * @param value indicar si se puede borrar
    */
    set canRemove(value) {
        this._canRemove = value;
    }
    /**
     * Permite obtener si el elemento se puede guardar.
     */
    get canSave() {
        return this._canSave;
    }
    /**
    * Permite definir si el elemento se puede guardar
    *
    * @param value indicar si se puede guardar
    */
    set canSave(value) {
        this._canSave = value;
    }
    /**
     * Permite obtener el icono definido
     */
    get icon() {
        return this._icon;
    }
    /**
    * Permite definir el icono a mostrar
    *
    * @param value indicar el nombre del icono a mostrar
    */
    set icon(value) {
        this._icon = value;
    }
    /**
   * Permite obtener el objeto que representa el elemento.
   */
    get value() {
        return this._value;
    }
    /**
     * Permite definir el objeto que representa el elemento.
     *
     * @param value recibe el objeto de datos que representa el elemento.
     */
    set value(value) {
        this._value = value;
    }
    /**
     * Permite obtener la estrategia de edición.
     */
    get editStrategy() {
        return this._editStrategy;
    }
    /**
     * Permite definir la estrategia de edición
     *
     * @param value recibe un objeto del tipo BaseEditStrategy que definirá la estrategia de edición.
     */
    set editStrategy(value) {
        this._editStrategy = value;
    }
    //#endregion
    //#region Output
    /**
     * Emite un evento cuando se borra un elemento
     */
    get remove() {
        return this._remove;
    }
    /**
     * Emite un evento cuando se guarda un elemento
     */
    get save() {
        return this._save;
    }
    /**
     * Emite un evento cuando se descarta la edición de un elemento.
     */
    get discard() {
        return this._discard;
    }
    /**
    * Emite un evento cuando se empieza a editar un elemento.
    */
    get editionStarted() {
        return this._editionStarted;
    }
}
DataListItemComponent.ɵfac = function DataListItemComponent_Factory(t) { return new (t || DataListItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DataListItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataListItemComponent, selectors: [["ngwk-data-list-item"]], inputs: { canEdit: "canEdit", canRemove: "canRemove", canSave: "canSave", icon: "icon", value: "value", editStrategy: "editStrategy" }, outputs: { remove: "remove", save: "save", discard: "discard", editionStarted: "editionStarted" }, ngContentSelectors: _c4, decls: 6, vars: 4, consts: [[1, "rowAuto", "horizontalLayout", "alignVerticalMiddle", 2, "height", "100%"], ["class", "colAuto iconFixDataList", 4, "ngIf"], [1, "colAvailable", 2, "height", "100%"], ["class", "dataListReadView", 4, "ngIf"], ["class", "dataListEditView", 4, "ngIf"], ["class", "colAuto alignVerticalMiddle transparentToolbar", 4, "ngIf"], [1, "colAuto", "iconFixDataList"], [3, "key"], [1, "dataListReadView"], [1, "dataListEditView"], [1, "colAuto", "alignVerticalMiddle", "transparentToolbar"], [4, "ngIf"], ["icon", "editIcon", 3, "visible", "actionClick"], ["icon", "trash", 3, "visible", "actionClick"], ["icon", "checkIcon", 1, "greenIcon", 3, "disabled", "actionClick"], ["icon", "closeIcon", 1, "redIcon", 3, "actionClick"]], template: function DataListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DataListItemComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DataListItemComponent_div_3_Template, 2, 0, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DataListItemComponent_div_4_Template, 2, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DataListItemComponent_div_5_Template, 3, 2, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.allowEdit || ctx.allowRemove || ctx.isEditMode);
    } }, directives: [ɵngcc3.NgIf, ɵngcc6.IconComponent, ɵngcc7.ToolbarComponent, ɵngcc7.ToolbarItemComponent], encapsulation: 2 });
/** @nocollapse */
DataListItemComponent.ctorParameters = () => [
    { type: ElementRef }
];
DataListItemComponent.propDecorators = {
    canEdit: [{ type: Input }],
    canRemove: [{ type: Input }],
    canSave: [{ type: Input }],
    icon: [{ type: Input }],
    value: [{ type: Input }],
    editStrategy: [{ type: Input }],
    remove: [{ type: Output }],
    save: [{ type: Output }],
    discard: [{ type: Output }],
    editionStarted: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataListItemComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-data-list-item",
                template: "<div class=\"rowAuto horizontalLayout alignVerticalMiddle\" style=\"height: 100%\">\r\n  <div *ngIf=\"icon\" class=\"colAuto iconFixDataList\">\r\n    <ucc-icon [key]=\"icon\"></ucc-icon>\r\n  </div>\r\n  <div class=\"colAvailable\" style=\"height: 100%\">\r\n    <div class=\"dataListReadView\" *ngIf=\"!isEditMode\">\r\n        <ng-content select=\"read-view\"></ng-content>\r\n    </div>\r\n    <div class=\"dataListEditView\" *ngIf=\"isEditMode\">\r\n      <ng-content select=\"edit-view\"></ng-content>\r\n    </div>\r\n  </div>\r\n    <div *ngIf=\"allowEdit || allowRemove || isEditMode\" class=\"colAuto alignVerticalMiddle transparentToolbar\">\r\n      <ngwk-toolbar *ngIf=\"!isEditMode && isMenuActive\">\r\n        <ngwk-toolbar-item [visible]=\"allowEdit\" icon='editIcon' (actionClick)='onEdit($event)'></ngwk-toolbar-item>\r\n        <ngwk-toolbar-item [visible]=\"allowRemove\" icon='trash' (actionClick)='onRemove($event)'></ngwk-toolbar-item>\r\n      </ngwk-toolbar>\r\n      <ngwk-toolbar *ngIf=\"isEditMode\">\r\n        <ngwk-toolbar-item class=\"greenIcon\" [disabled]=\"!canSave\" icon='checkIcon' (actionClick)='onSave($event)'></ngwk-toolbar-item>\r\n        <ngwk-toolbar-item class=\"redIcon\" icon='closeIcon' (actionClick)='onDiscard($event)'></ngwk-toolbar-item>\r\n      </ngwk-toolbar>\r\n    </div>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { canEdit: [{
            type: Input
        }], canRemove: [{
            type: Input
        }], canSave: [{
            type: Input
        }], icon: [{
            type: Input
        }], value: [{
            type: Input
        }], editStrategy: [{
            type: Input
        }], remove: [{
            type: Output
        }], save: [{
            type: Output
        }], discard: [{
            type: Output
        }], editionStarted: [{
            type: Output
        }] }); })();

class DataListModule {
}
DataListModule.ɵfac = function DataListModule_Factory(t) { return new (t || DataListModule)(); };
DataListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataListModule });
DataListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ToolbarModule,
            IconModule,
            ScrollingModule,
            LocalizationModule,
            LoadingDataModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ToolbarModule,
                    IconModule,
                    ScrollingModule,
                    LocalizationModule,
                    LoadingDataModule
                ],
                declarations: [
                    DataListComponent,
                    DataListItemComponent
                ],
                exports: [
                    DataListComponent,
                    DataListItemComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataListModule, { declarations: function () { return [DataListComponent, DataListItemComponent]; }, imports: function () { return [CommonModule,
        ToolbarModule,
        IconModule,
        ScrollingModule,
        LocalizationModule,
        LoadingDataModule]; }, exports: function () { return [DataListComponent, DataListItemComponent]; } }); })();

/**
 * Classe que nos permite definir la estrategia de edición en el DataList.
 * En este caso, sólo nos permite tener un elemento en modo edición al mismo tiempo.
 */
class SingleEditStrategy {
    constructor() {
        /** @ignore */
        this._backupEditedValues = new Map();
        //#endregion
    }
    //#region Restore Values
    /**
     * ver [BaseEditStrategy]{@link BaseEditStrategy}
     */
    set(value) {
        this._backupEditedValues.set(value, Reflection.clone(value));
    }
    /**
    * ver [BaseEditStrategy]{@link BaseEditStrategy}
    */
    get(value) {
        return this._backupEditedValues.get(value);
    }
    /**
    * ver [BaseEditStrategy]{@link BaseEditStrategy}
    */
    exist(value) {
        return this._backupEditedValues.has(value);
    }
    /**
    * ver [BaseEditStrategy]{@link BaseEditStrategy}
    */
    remove(value) {
        return this._backupEditedValues.delete(value);
    }
    /**
    * ver [BaseEditStrategy]{@link BaseEditStrategy}
    */
    discardChanges(value) {
        if (this.exist(value)) {
            Reflection.sync(this._backupEditedValues.get(value), value);
            this.remove(value);
        }
    }
    /**
     * ver [BaseEditStrategy]{@link BaseEditStrategy}
     */
    clear() {
        this._backupEditedValues.clear();
    }
    //#endregion
    //#region Properties
    /**
    * ver [BaseEditStrategy]{@link BaseEditStrategy}
    */
    get canEdit() {
        return this._backupEditedValues && this._backupEditedValues.size === 0;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { DataListComponent, DataListItemComponent, DataListModule, DataListPaginationMode, DataListSelectionMode, DataListSelectionModeHelper, SingleEditStrategy };

